import themeGet from "@styled-system/theme-get";
import styled from "styled-components";

export const CustomMenuList = styled.div`
  overflow-y: auto;
  padding-bottom: 1px;
  padding-top: 0;
  position: relative;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  max-height: 80vh;
`;

export const CustomMenu = styled.div`
  background-color: ${(props) => themeGet("colors.white")(props)};
  border-radius: ${(props) => themeGet("radii.2")(props)};
  margin: ${(props) => themeGet("space.s")(props)} 0;
  box-shadow:
    0 0 0 1px hsla(0, 0%, 0%, 0.1),
    0 4px 11px hsla(0, 0%, 0%, 0.1);
  z-index: 1;
  box-sizing: border-box;
  width: calc(100vw - 32px);
  left: 16px;
  position: fixed;
  /* Dynamic position under search bar when menuTop is measured */
  top: ${(props) =>
    props.$menuTop != null
      ? `${props.$menuTop}px`
      : `calc(${themeGet("appScale.navBarSize")(props) || "48px"} + 88px)`};
  overflow: hidden;

  @media screen and (min-width: 700px) {
    width: 100%;
    position: absolute;
    left: 0;
    top: 100%;
  }
`;
